module.exports = __webpack_public_path__ + "img/placeholder-user.3f54a281.svg";